import React from "react";
import { PayPalButton } from "react-paypal-button-v2";

const paypalKey = process.env.REACT_APP_PAYPAL_CLIENT_ID;

export const OrderBtn = ({
  createOrder,
  onApprove,
  catchError,
  onError,
  onCancel,
  setButtonReady,
}) => {
  // Don't render PayPal button if client ID is not configured
  if (!paypalKey || paypalKey === 'undefined') {
    console.warn('PayPal Client ID not configured. Set REACT_APP_PAYPAL_CLIENT_ID in your .env file');
    return (
      <div style={{ 
        padding: '1rem', 
        background: '#FFF8E1', 
        border: '1px solid #F57C00',
        borderRadius: '6px',
        color: '#5a3e2b',
        textAlign: 'center'
      }}>
        <strong>PayPal Not Configured</strong>
        <p style={{ fontSize: '0.875rem', margin: '0.5rem 0 0 0' }}>
          PayPal client ID is missing. This is normal in development.
        </p>
      </div>
    );
  }

  return (
    <PayPalButton
      amount={10}
      onButtonReady={() => setButtonReady(true)}
      createOrder={(data, details) => createOrder(data, details)}
      onApprove={(data, details) => onApprove(data, details)}
      onError={(err) => onError(err)}
      catchError={(err) => catchError(err)}
      onCancel={(err) => onCancel(err)}
      options={{
        clientId: paypalKey,
      }}
      style={{
        shape: "rect",
        color: "blue",
        layout: "vertical",
      }}
    />
  );
};
export default OrderBtn;
